import React from 'react'
// import Sun from "@iconscout/react-unicons/icons/uil-sun"
// import Moon from "@iconscout/react-unicons/icons/uil-moon"
import Context from '../../Context'
const Toggle = () => {
  return (
    <div className='toggle'>  
          <Context/>
    </div>
  )
}

export default Toggle
